/// <reference types="../node_modules/@types/jquery" />

import * as $ from 'jquery';
import * as ko from 'knockout';

export abstract class ServerRequestComponent {
    abstract SEND_REQUEST_URL;

    isBusy: KnockoutObservable<boolean>;
    isSent: KnockoutObservable<boolean>;
    error: KnockoutObservable<string>;

    constructor() {
        this.isBusy = ko.observable<boolean>(false);
        this.isSent = ko.observable<boolean>(false);
        this.error = ko.observable<string>();
    }

    abstract createRequest();

    doRequest(e) {
        this.isBusy(true);

        $.ajax({
            method: 'POST',
            url: this.SEND_REQUEST_URL,
            data: this.createRequest(),
            dataType: 'json',
            headers : {
                'accepts' :'application/json'
            }
        })
            .done((r) => {
                this.isBusy(false);
                if (r.ok) {
                    this.isSent(true);
                } else {
                    this.error(r.error);
                }
            })
            .fail(fl => {
                this.isBusy(false);
                this.error("Внутреннаяя ошибка. Обратитесь в техподдержку");
            });
    }
}